import { Box, IconButton, Modal } from '@mui/material';
import { Delete } from '@mui/icons-material';
import AudioPicker from 'components/AdminBooks/AudioPicker';
import React from 'react';
import ReactPlayer from 'react-player';
import { hasAudioUrl } from 'utils/methods/downloadAudioFile';
import { closeModal } from 'utils/assets/images';
import { AudioDownloadButton } from 'components/UI';

const style = {};

const AudioUploaderNonNativeAdmin = ({ audioUrl, openAudioModal, handleClose, getUrl, has_delete, modalZIndex = 1400, hideModalBackdrop = false }) => {
    const resolvedAudioUrl = hasAudioUrl(audioUrl) ? String(audioUrl).trim() : '';

    return (
        <Modal open={openAudioModal} onClose={handleClose} className="modelCntnt" hideBackdrop={hideModalBackdrop} sx={{ zIndex: modalZIndex, pointerEvents: openAudioModal ? 'auto' : 'none' }}>
            <Box sx={style} className="modelCntntIner modalVideoPlay">
                <div className="lernModalBg">
                    <div className="modelDtl modelDtlAUdio">
                        <div style={{ zIndex: 70 }} className="closeModelInfo" onClick={handleClose}>
                          {has_delete&&audioUrl?<IconButton style={{backgroundColor:"red", height:30, width:30}} onClick={()=>{getUrl(null);handleClose()}}><Delete style={{color:"#fff"}}/></IconButton>:null}  <img style={{ height: "30px" }} src={closeModal} onClick={handleClose} />
                        </div>
                        <AudioPicker
                            message={"Upload a audio file for question..."}
                            onChange={v => {
                                getUrl(v);
                            }}
                        />
                        {resolvedAudioUrl ? (
                            <>
                                <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginBottom: '8px' }}>
                                    <ReactPlayer
                                        url={resolvedAudioUrl}
                                        height="40px"
                                        width="50%"
                                        controls
                                        playsinline
                                        config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                                    />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                                    <AudioDownloadButton audioUrl={resolvedAudioUrl} />
                                </div>
                            </>
                        ) : null}
                    </div>
                </div>
            </Box>
        </Modal>
    )
}

export default AudioUploaderNonNativeAdmin;
